import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import EntryCards from "@/pages/home/components/EntryCards";
import InstallSteps from "@/pages/home/components/InstallSteps";
import AddressTimeline from "@/pages/home/components/AddressTimeline";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full">
        <Hero />
        <EntryCards />
        <InstallSteps />
        <AddressTimeline />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}